import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "book-reading-nav" }
const _hoisted_2 = { class: "book-reading-nav__container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "book-reading-nav__link" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "book-reading-nav__icon iconfont iprev" }),
  /*#__PURE__*/_createTextVNode("Previous ")
], -1)
const _hoisted_4 = { class: "book-reading-nav__name book-reading-nav__prev-name" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "book-reading-nav__link" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "book-reading-nav__icon iconfont iprev" }),
  /*#__PURE__*/_createTextVNode("Back ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "book-reading-nav__name book-reading-nav__prev-name" }, " Back to Preview page ", -1)
const _hoisted_7 = { class: "book-reading-nav__container" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "book-reading-nav__link book-reading-nav__next" }, [
  /*#__PURE__*/_createTextVNode(" Next"),
  /*#__PURE__*/_createElementVNode("span", { class: "book-reading-nav__icon iconfont inext" })
], -1)
const _hoisted_9 = { class: "book-reading-nav__name book-reading-nav__next-name" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "book-reading-nav__link book-reading-nav__next" }, [
  /*#__PURE__*/_createTextVNode(" Done"),
  /*#__PURE__*/_createElementVNode("span", { class: "book-reading-nav__icon iconfont inext" })
], -1)
const _hoisted_11 = { class: "book-reading-nav__name book-reading-nav__next-name" }

import { DocView } from '@/models/doc'


export default /*#__PURE__*/_defineComponent({
  __name: 'PrevNext',
  props: {
    doc: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.doc.prevLink.exists)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            replace: "",
            to: __props.doc.prevLink.params,
            class: "book-reading-nav__prev-box"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createElementVNode("p", _hoisted_4, _toDisplayString(__props.doc.prevLink.title), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            replace: "",
            to: __props.doc.previewLink.params,
            class: "book-reading-nav__prev-box"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          }, 8, ["to"]))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (__props.doc.nextLink.exists)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            replace: "",
            to: __props.doc.nextLink.params,
            class: "book-reading-nav__next-box"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createElementVNode("p", _hoisted_9, _toDisplayString(__props.doc.nextLink.title), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "book-reading-nav__next-box",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.doc.doneClick()))
          }, [
            _hoisted_10,
            _createElementVNode("p", _hoisted_11, _toDisplayString(__props.doc.doneText), 1)
          ]))
    ])
  ]))
}
}

})